import { useEffect, useRef, useState } from 'react'
import { useEditor } from '../store/context'

export function ImageDialog() {
  const { store } = useEditor()

  const dialogRef = useRef<HTMLDialogElement>(null)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const [tab, setTab] = useState<'upload' | 'url'>('upload')
  const [url, setUrl] = useState('')

  useEffect(() => {
    store.subscribeImageDialog(() => {
      setTab('upload')
      setUrl('')
      dialogRef.current!.showModal()
    })
    // eslint-disable-next-line react/exhaustive-deps
  }, [])

  function close() {
    dialogRef.current!.close()
  }

  async function onFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const files = e.target.files
    if (!files?.length)
      return
    close()
    await store.uploadFiles(files)
  }

  function insertUrl() {
    if (!url)
      return
    store.editor().chain().focus().setImage({ src: url }).run()
    close()
  }

  return (
    <dialog
      ref={dialogRef}
      className="tiptap-dialog"
      onClick={(e) => {
        if (e.target === dialogRef.current)
          close()
      }}
    >
      <p className="dialog-title">Insert image</p>

      <div className="tabs">
        <button type="button" className={`tab${tab === 'upload' ? ' is-active' : ''}`} onClick={() => setTab('upload')}>
          Upload file
        </button>
        <button type="button" className={`tab${tab === 'url' ? ' is-active' : ''}`} onClick={() => setTab('url')}>
          From URL
        </button>
      </div>

      {tab === 'upload'
        ? (
            <div className="tab-panel">
              <div className="file-drop-area" onClick={() => fileInputRef.current?.click()}>
                Click to choose an image
                <input ref={fileInputRef} type="file" accept="image/*" onChange={onFileChange} />
              </div>
            </div>
          )
        : (
            <div className="tab-panel">
              <input
                className="url-input"
                type="url"
                placeholder="https://example.com/image.png"
                value={url}
                onChange={e => setUrl(e.target.value.trim())}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && url)
                    insertUrl()
                }}
              />
            </div>
          )}

      <div className="dialog-actions">
        <button type="button" className="btn btn-cancel" onClick={close}>Cancel</button>
        {tab === 'url' && (
          <button type="button" className="btn btn-primary" disabled={!url} onClick={insertUrl}>
            Insert
          </button>
        )}
      </div>
    </dialog>
  )
}
